import { Component } from '@angular/core';
import { DownloadTripsListComponent } from "../download-trips-list/download-trips-list.component";

@Component({
  selector: 'app-statistics-page',
  imports: [DownloadTripsListComponent],
  templateUrl: './statistics-page.component.html'
})
export class StatisticsPageComponent {

}
